import { render, staticRenderFns } from "./PosConfig.vue?vue&type=template&id=77d635e6"
import script from "./PosConfig.vue?vue&type=script&lang=js"
export * from "./PosConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports